import type { TopExhibitorDto } from '@/shared/types/domain';

export function TopExhibitorsChart({ exhibitors }: { exhibitors: TopExhibitorDto[] }) {
  const max = Math.max(...exhibitors.map((e) => e.scanCount), 1);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
      {exhibitors.map((ex, i) => (
        <div key={ex.exhibitorId} style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
          <span style={{ width: 20, color: 'var(--text-muted)', fontSize: '0.8125rem', flexShrink: 0 }}>{i + 1}</span>
          <span style={{ width: 160, flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {ex.companyName}
          </span>
          <div style={{ flex: 1, background: 'var(--surface-raised)', borderRadius: 'var(--radius-full)', height: 20, position: 'relative' }}>
            <div
              style={{
                width: `${(ex.scanCount / max) * 100}%`,
                background: 'var(--accent)',
                height: '100%',
                borderRadius: 'var(--radius-full)',
                transition: 'width 0.4s ease'
              }}
            />
          </div>
          <span className="font-mono" style={{ width: 40, textAlign: 'right', color: 'var(--text-muted)', fontSize: '0.875rem' }}>
            {ex.scanCount}
          </span>
        </div>
      ))}
    </div>
  );
}
